import '../main'
import csCheckbox from './src/checkbox.vue'


csCheckbox.install = function (Vue) {
    Vue.component(csCheckbox.name, csCheckbox)
}



export default csCheckbox


// WEBPACK FOOTER //
// ./src/components/checkbox/index.js